<template>
  <div>
    <a-modal
        :title="title"
        :visible="visible"
        width="100%"
        :dialog-style="{ top: '0px', 'padding-bottom': '0px'}"
        :body-style="{ 'background-color': 'rgb(236, 236, 236)'}"
        :footer="null"
        @cancel="handleCancel">
      <DetailCreateTable ref="detailCreateTable" style="margin-bottom: 50px" @before="handleBefore"
                           @complete="handleCommit($event)" @finally="handleFinally"
                           @completeDraft="handleCancel"></DetailCreateTable>

      <div class="modal-footer">
        <a-button key="back" @click="handleCancel" style="margin-left: 8px">
          关闭
        </a-button>
        <a-button v-if="title === '继续完善'" type="primary" @click="handleDraft"
                  style="margin-left: 8px">
          保存
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>

import DetailCreateTable from "@/components/krDs/DetailCreateTable";

export default {
  name: "DetailCreateModal",
  components: {DetailCreateTable},
  data() {
    return {
      title: '',
      visible: false,
      loading: false,
      fatherModal: '',
    }
  },
  methods: {
    handleDraft() {
      this.$refs.detailCreateTable.handleDraft();
    },
    show(data, title, fatherModal) {
      this.visible = true;
      this.title = title;
      this.fatherModal = fatherModal;
      this.$nextTick(() => {
        this.$refs.detailCreateTable.init(data);
      })
    },
    handleBefore() {
      this.loading = true;
    },
    handleFinally() {
      this.loading = false;
    },
    handleCommit() {
      this.handleCancel();
      this.$message.success("已提交");
    },
    handleCancel() {
      this.visible = false;
      if (this.fatherModal) {
        this.fatherModal.$emit('ok');
      }
    }
  }

}

</script>

<style scoped>

.modal-footer {
  position: fixed;
  bottom: 0px;
  left: 24px;
  right: 33px;
  z-index: 999;

  padding: 10px 16px;
  text-align: right;
  background: white;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;

}

</style>
